import { useState, useEffect } from "react";
import axios from "axios";
import { useHistory } from "react-router-dom";
import HeaderReportMp from "../../../../Components/ComponentsMarketplace/HeaderReportMp";
import ButtonsMap from "../../../../Components/ComponentsMarketplace/ButtonsMap";
import Countdown from 'react-countdown';

import {
  ContainerMenu,
  ImgButtonsTools,
  ToolsButton,
} from "./style";
import ModalVisitCustomer from "../../../../Components/ComponentsIndustry/ModalVisitCustomer";
import {
  Container,
  SizeContainer,
  TitleContainer,
  TitleContent,
  VisitContainer,
  InternalVisitContainer,
  AddContainer,
  Signal,
  AddVisit,
  MainContainer,
  AvailabelStock,
  SubTitle,
  RequestContainer,
  FirstRequestContainer,
  ButtonContainer,
  SecondRequestContainer,
  ButtonRequest,
  FirstMarketngContainer,
  MarketngContainer,
  CountMarketngContainer,
  TotalContainer,
  CountdownContainer,
} from "../style";
import { useUser } from "../../../../providers/UserContext";
import { useChicken } from "../../../../providers/ChickenContext";
import { useCommercialSales } from "../../../../providers/CommercialSalesContext";

const MpPurchasesChickenCut = () => {
  const history = new useHistory()

  const { user, rodada } = useUser()
  const { infoChicken } = useChicken()

  const {
    currentNegociation,
    timer,
    intervalId,
    setIntervalId,
    setStatusContext,
    setCompaniesVisitScheduled,
    setCurrentNegociation,
    statusContext,
    getIndustriesScheduled,
    industriesVisitScheduled,
    setCurrentScheduling,
    currentScheduling,
    setCurrentVisita,
    currentVisita } = useCommercialSales()
  const [showModal, setShowModal] = useState(false)

  const [inCash, setInCash] = useState(false);
  const [thirtyDays, setThirtyDays] = useState(false);
  const [showPedido, setShowPedido] = useState(false)
  const [caixas, setCaixas] = useState('')
  const [precoMedio, setPrecoMedio] = useState(0)
  const [status, setStatus] = useState('')
  const [error, setError] = useState('')
  const [encarteTotal, setEncarteTotal] = useState(0)
  const [encartePrice, setEncartePrice] = useState(0)
  const [tvTotal, setTvTotal] = useState(0)
  const [tvPrice, setTvPrice] = useState(0)
  const [radioTotal, setRadioTotal] = useState(0)
  const [radioPrice, setRadioPrice] = useState(0)
  const [repositoraPrice, setRepositoraPrice] = useState(0)
  const [repositoraTotal, setRepositoraTotal] = useState(0)
  const [demonstradoraPrice, setDemonstradoraPrice] = useState(0)
  const [demonstradoraTotal, setDemonstradoraTotal] = useState(0)

  const api = axios.create({
    baseURL: "https://sistemas.sisinfor.com.br/BusinessGameBack"
  })

  function setAllStates(responseData) {

    responseData?.itens?.forEach(element => {

      if (element.produto.produto === 8) {
        element?.preco ? setPrecoMedio(element.preco) : setPrecoMedio(0)
        setCaixas(element?.quantidade)
        element?.encarteTotal ? setEncartePrice(element?.encarteTotal) : setEncartePrice(0)
        setEncarteTotal(element?.encarteQuantidade)
        element?.repositoraTotal ? setRepositoraPrice(element?.repositoraTotal) : setRepositoraPrice(0)
        setRepositoraTotal(element?.repositoraQuantidade)
        element?.demonstradoraTotal ? setDemonstradoraPrice(element?.demonstradoraTotal) : setDemonstradoraPrice(0)
        setDemonstradoraTotal(element?.demonstradoraQuantidade)
        element?.tvTotal ? setTvPrice(element?.tvTotal) : setTvPrice(0)
        setTvTotal(element?.tvQuantidade)
        element?.radioTotal ? setRadioPrice(element?.radioTotal) : setRadioTotal(0)
        setRadioTotal(element?.radioQuantidade)
      }

    });

  }

  function handleClickedVisita(market) {

    api.get(`/api/visita/listarNegociacoes/${market.visita}`)
      .then(response => {

        setCurrentVisita(market)
        setCurrentScheduling(response?.data[0])
        setCurrentNegociation(response?.data[0]?.itens ? response?.data[0]?.itens : [])
        const responseData = response?.data[0]
        setAllStates(responseData)
        setStatusContext(response?.data[0]?.status)
        setShowPedido(true)

      })

  }

  const renderer = ({ minutes, seconds }) => {

    // if (Number(minutes) === 0 && Number(seconds) === 0) {

    // finishedTimeVisita()

    // }
    // Render a countdown
    return <CountdownContainer>{minutes}:{seconds}</CountdownContainer>;

  };

  function sendOffer() {

    const data = {
      "demonstradoraCusto": 3500 / 4,
      "demonstradoraQuantidade": demonstradoraTotal,
      "demonstradoraTotal": demonstradoraPrice,
      "encarteCusto": 1250,
      "encarteQuantidade": encarteTotal,
      "encarteTotal": encartePrice,
      "negociacaoItem": 0,
      "preco": precoMedio,
      "produto": {
        "produto": 8,
        "nome": "Frango Inteiro"
      },
      "quantidade": caixas,
      "total": precoMedio,
      "radioCusto": 1500,
      "radioQuantidade": radioTotal,
      "radioTotal": radioPrice,
      "repositoraCusto": 800,
      "repositoraQuantidade": repositoraTotal,
      "repositoraTotal": repositoraPrice,
      "tvCusto": 2500,
      "tvQuantidade": tvTotal,
      "tvTotal": tvPrice
    }

    if (currentNegociation?.some(item => {
      return item.produto.produto === data.produto.produto
    })) {
      // console.log(currentNegociation.filter(item => item.produto.produto !== 8))
      const addArray = currentNegociation.filter(item => item.produto.produto !== 8)
      addArray.push(data)
      setCurrentNegociation(addArray)
      setShowModal(true)
    } else {
      setCurrentNegociation(currentNegociation => [...currentNegociation, data])
      setShowModal(true)
    }

  }

  const handleDeadline = (sub) => {
    switch (sub) {
      case "inCash":
        setInCash(true);
        setThirtyDays(false);
        break;
      case "thirtyDays":
        setInCash(false);
        setThirtyDays(true);
        break;
      default:
        break;
    }
  };

  const handleCaixas = (e) => {

    setCaixas(e.target.value)

    const calPrice = (e.target.value * infoChicken?.preco)

    setPrecoMedio(calPrice)
  }

  const handleMarketingPrice = (e, setTotalMarketing, setState, fator) => {

    setTotalMarketing(e.target.value)

    const calPrice = (e.target.value * fator)

    setState(calPrice)
  }

  useEffect(() => {


    getIndustriesScheduled()

    var intervalo = window.setInterval(callsVisitas, 10000);

    function callsVisitas() {

      // clearInterval(intervalo);
      getIndustriesScheduled()

    }
    return () => clearInterval(intervalo);
  }, [])

  useEffect(() => {

    if (statusContext) {

      if (statusContext === "A") {
        setShowPedido(true)
        setStatus("Aguardando")
      } else if (statusContext === "I") {
        setShowPedido(true)
        setStatus("Aguardando Indústria")
      }
      else if (statusContext === "P") {
        setShowPedido(true)
        setStatus("Aceito")
      }
      else if (statusContext === "R") {
        setShowPedido(true)
        setStatus("Rejeitado")
      } else {
        setShowPedido(true)
        setStatus("Faça uma proposta")
        if (currentNegociation?.some(item => {
          return item.produto.produto === 8
        })) {
          currentNegociation.forEach(element => {

            if (element.produto.produto === 8) {
              setPrecoMedio(element.preco)
              setCaixas(element.quantidade)
            }

          });

        }
      }

      if (statusContext === "A") {
        clearInterval(intervalId);
        setIntervalId(0);
        return;
      }

    }

  }, [statusContext])

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     if (currentVisita && statusContext) {

  //       console.log("1")

  //       if (statusContext === "I") {

  //         var intervalo = window.setInterval(() => {

  //           getCurrentNegociation(currentVisita.visita)
  //           console.log("2")

  //         }, 10000);

  //       } 

  //     } 
  //   }, 10000);

  //   return () => clearInterval(interval);
  // }, []);

  useEffect(() => {



    if (currentScheduling)
      setAllStates(currentScheduling)

  }, [currentScheduling])

  function acceptVisit(visita) {

    const now = new Date()

    visita.supermercadoUsuario = user
    visita.dataHora = `${now.getFullYear()}-${now.getMonth()}-${now.getDay()} ${now.getHours()}:${now.getMinutes()}:${now.getSeconds()}`
    visita.dataConfirmacao = `${now.getFullYear()}-${now.getMonth()}-${now.getDay()} ${now.getHours()}:${now.getMinutes()}:${now.getSeconds()}`

    api
      .post(`/api/visita/confirmar/${visita.visita}/${user?.usuario}`)
      .then(response => {
        if (user && rodada) {
          api.get(`/api/visita/listarSupermercado/${user.supermercado.supermercado}`)
            .then(response => {
              setCompaniesVisitScheduled(response.data)
            })
            .catch((error) => {
              console.log(error)
            })
        }
      })
      .catch((error) => {
        console.log(error)
      })

  }

  const handleResult = () => {

    if (isNaN(parseFloat(precoMedio) + parseFloat(encartePrice) + parseFloat(demonstradoraPrice) + parseFloat(tvPrice) + parseFloat(radioPrice) + parseFloat(repositoraPrice))) {
      return 0
    } else {
      return parseFloat(precoMedio) + parseFloat(encartePrice) + parseFloat(demonstradoraPrice) + parseFloat(tvPrice) + parseFloat(radioPrice) + parseFloat(repositoraPrice)
    }
  }

  return (
    <Container>
      {
        showModal &&
        <ModalVisitCustomer setShowModal={setShowModal} />

      }
      <SizeContainer>
        <HeaderReportMp
          title="COMPRAS"
          pathImg="./images/purchase_button.svg"
        />
        <TitleContainer>
          <TitleContent>
            <img src="./images/partnership.svg" alt="partnership" />

          </TitleContent>
          {/* <AddButton onClick={() => {
            setShowAllCompanies(!showAllCompanies)
          }}>+</AddButton> */}
          <VisitContainer>
            {
              industriesVisitScheduled.map((market, key) => {
                return <InternalVisitContainer key={key}>
                  <img src="./images/market_basket.svg" alt="market_basket" />
                  <p>{market.industria.nome}</p>
                  <AddContainer>
                    <Signal style={market.confirmada ?
                      {
                        backgroundColor: "#00a000",
                        boxShadow: "0 0 10px 5px rgba(1, 100, 1, 0.5)"
                      }
                      :
                      {
                        backgroundColor: "#ffd700",
                        boxShadow: "0 0 10px 5px rgba(255, 215, 0, 0.5)"
                      }
                    }
                    />
                    <AddVisit
                      onClick={() => {
                        if (market.confirmada) {
                          handleClickedVisita(market)
                        } else {
                          acceptVisit(market)
                        }
                      }}
                    >
                      +
                    </AddVisit>
                  </AddContainer>
                </InternalVisitContainer>
              })
            }


          </VisitContainer>
          <TitleContent>Visitas agendadas</TitleContent>
        </TitleContainer>
        <ContainerMenu>
          <ToolsButton onClick={() => history.push("/mpPurchasesSausage")}>
            <ImgButtonsTools
              src="./images/sausage_gray.svg"
              alt="sausage_pcp"
            />
          </ToolsButton>
          <ToolsButton className={"selection"} >
            <ImgButtonsTools
              src="./images/chicken_gray.svg"
              alt="chicken_pcp"
            />
          </ToolsButton>
          <ToolsButton onClick={() => history.push("/mpPurchasesChickenCut")}>
            <ImgButtonsTools
              src="./images/chicken_cut_gray.svg"
              alt="cut_chicken_pcp"
            />
          </ToolsButton>
          <ToolsButton onClick={() => history.push("/mpPurchasesFries")} >
            <ImgButtonsTools src="./images/fries_gray.svg" alt="fries_pcp" />
          </ToolsButton>
        </ContainerMenu>
        <MainContainer>
          <h2>
            Produção de <small>Frango</small>
          </h2>
          <AvailabelStock>
            <h3>
              <img src="./images/productions.svg" alt="productions" /> Estoque
              Disponível
            </h3>
            <p>0</p> <small>KG</small>
          </AvailabelStock>
          {
            showPedido && currentVisita?.confirmada ?
              (
                <>
                  <RequestContainer>
                    <SubTitle>
                      <img src="./images/ticket.svg" alt="ticket" />
                      <div style={{ marginTop: "20px" }}>Pedido de {currentVisita && currentVisita.supermercado.nome} ({status})
                      </div>
                      <div style={{ marginTop: "5px" }}>
                        {
                          status !== "Aceito" ?
                            <Countdown renderer={renderer}
                              date={new Date(timer)}
                            /> :
                            <></>
                        }
                      </div>
                    </SubTitle>
                    <FirstRequestContainer>
                      <div>
                        <small>Quantidade de Caixas</small>
                        <input value={caixas} onChange={(e) => handleCaixas(e)} type="number" placeholder="0" />
                      </div>
                      <p>
                        R$<input value={precoMedio} onChange={(e) => setPrecoMedio(e.target.value)} type="number" placeholder="0" /><img src="./images/box.svg" alt="box" />
                      </p>
                      <div className="buttons">
                        <ButtonContainer>
                          <p>á vista</p>
                          {inCash ? (
                            <button
                              className="checked"
                              onClick={() => handleDeadline("inCash")}
                            />
                          ) : (
                            <button onClick={() => handleDeadline("inCash")} />
                          )}
                        </ButtonContainer>
                        <ButtonContainer>
                          <p>30 dias</p>
                          {thirtyDays ? (
                            <button
                              className="checked"
                              onClick={() => handleDeadline("thirtyDays")}
                            />
                          ) : (
                            <button onClick={() => handleDeadline("thirtyDays")} />
                          )}
                        </ButtonContainer>
                      </div>
                    </FirstRequestContainer>
                    <SecondRequestContainer>
                    </SecondRequestContainer>
                  </RequestContainer>

                  <SubTitle>
                    <img src="./images/marketing.svg" alt="marketing" />
                    Marketing e Promoção
                  </SubTitle>
                  <MarketngContainer>
                    <FirstMarketngContainer>

                      <CountMarketngContainer>
                        <input placeholder="0" type={"number"} value={repositoraTotal} onChange={(e) => handleMarketingPrice(e, setRepositoraTotal, setRepositoraPrice, 800)} />
                        <p>Repositora</p>
                        <small>3.200/mês</small>
                        <div>
                          <input value={repositoraPrice} onChange={(e) => setRepositoraPrice(e.target.value)}></input> <img src="./images/cifrao.svg" alt="cifrao" />
                        </div>
                      </CountMarketngContainer>

                      <CountMarketngContainer>
                        <input placeholder="0" type={"number"} value={encarteTotal} onChange={(e) => handleMarketingPrice(e, setEncarteTotal, setEncartePrice, 1250)} />
                        <p>Encarte</p>
                        <small>5.000/mês</small>
                        <div>
                          <input value={encartePrice} onChange={(e) => setEncartePrice(e.target.value)}></input> <img src="./images/cifrao.svg" alt="cifrao" />
                        </div>
                      </CountMarketngContainer>

                      <CountMarketngContainer>
                        <input placeholder="0" type={"number"} value={tvTotal} onChange={(e) => handleMarketingPrice(e, setTvTotal, setTvPrice, 2500)} />
                        <p>TV</p>
                        <small>10.000/mês</small>
                        <div>
                          <input value={tvPrice} onChange={(e) => setTvPrice(e.target.value)}></input> <img src="./images/cifrao.svg" alt="cifrao" />
                        </div>
                      </CountMarketngContainer>

                      <CountMarketngContainer>
                        <input placeholder="0" type={"number"} value={radioTotal} onChange={(e) => handleMarketingPrice(e, setRadioTotal, setRadioPrice, 1500)} />
                        <p>Rádio</p>
                        <small>6.000/mês</small>
                        <div>
                          <input value={radioPrice} onChange={(e) => setRadioPrice(e.target.value)} ></input> <img src="./images/cifrao.svg" alt="cifrao" />
                        </div>
                      </CountMarketngContainer>

                      <CountMarketngContainer>
                        <input placeholder="0" type={"number"} value={demonstradoraTotal} onChange={(e) => handleMarketingPrice(e, setDemonstradoraTotal, setDemonstradoraPrice, 3500 / 4)} />
                        <p>Demonstradora</p>
                        <small>3.500/mês</small>
                        <div>
                          <input value={demonstradoraPrice} onChange={(e) => setDemonstradoraPrice(e.target.value)} ></input> <img src="./images/cifrao.svg" alt="cifrao" />
                        </div>
                      </CountMarketngContainer>
                    </FirstMarketngContainer>
                    <TotalContainer>
                      <p>
                        Total
                        <small>Marketing e Pedido</small>
                      </p>
                      <div>
                        R$ {handleResult()} <img src="./images/cifrao.svg" alt="cifrao" />
                      </div>
                    </TotalContainer>
                  </MarketngContainer>
                  {
                    statusContext !== "I" && statusContext !== "P" ?
                      <ButtonRequest onClick={() => sendOffer()} style={{ background: "#ffd700" }}>Enviar</ButtonRequest> :
                      <></>
                  }
                  {/* {status === "Rejeitado" ? 
                (
                  <h2>Sua oferta foi rejeitada...</h2>
                )
                :
                status === "Faça uma proposta" ?
                (<ButtonRequest onClick={() => sendOffer("A")} style={{background: "#ffd700"}}>Enviar</ButtonRequest>)
                :
                status === "Aceito" ?
                (
                  <h2>Sua oferta foi aceita!</h2>
                )
                :
                status === "Aguardando Supermercado" ?
                (
                  <></>
                ) :
                (
                  <>
                    <ButtonRequest onClick={() => sendOffer("P")} >Aceitar</ButtonRequest>
                    <ButtonRequest onClick={() => sendOffer("A")} style={{background: "#ffd700"}}>Enviar</ButtonRequest>
                    <ButtonRequest onClick={() => sendOffer("R")} style={{background: "red"}}>Rejeitar</ButtonRequest>
                  </>
                )
                
                
                } */}
                </>)
              :
              (
                <RequestContainer style={{ color: "white", }}>
                  <h2>{error}</h2>
                </RequestContainer>
              )
          }

          {/* 
          <Total>
            <Icon
              src="./images/commercial_button.svg"
              alt="commercial_button"
            />
            <div>
            <h3>Total</h3>
            <p>
              D$ 0,00<img src="./images/cifrao.svg" alt="cifrao" />
            </p>
            </div>
          </Total> */}
        </MainContainer>
        <ButtonsMap />
      </SizeContainer>
    </Container>
  );
};
export default MpPurchasesChickenCut;
